<template>
	<div class="container">
		<div class="header">
			<h2>Loan Status Summary</h2>
		</div>
		<div class="item">
			<span class="label">Loan Id</span>
			<span class="dots"></span>
			<span class="value">{{ loanDetails.loan.referenceId }}</span>
		</div>
		<div class="item">
			<span class="label">App Completion Date</span>
			<span class="dots"></span>
			<span class="value">{{ loanDetails.applicationCompletionDateFormatted }}</span>
		</div>
		<div class="item">
			<span class="label">Status</span>
			<span class="dots"></span>
			<span class="value">{{ loanDetails.loanStatusHumanized }}</span>
		</div>
		<div class="item">
			<span class="label">Status Reason</span>
			<span class="dots"></span>
			<span class="value">{{ loanDetails.loanStatusReasonHumanized }}</span>
		</div>
		<div v-if="loanDetails.loan.productType === 1" class="item">
			<span class="label">LOC Draw Status</span>
			<span class="dots"></span>
			<span class="value">{{ loanDetails.locStatusHumanized }}</span>
		</div>
	</div>
</template>

<script setup lang="ts">
	import type { LoanDetails } from '@/models/loans';

	defineProps<{
		loanDetails: LoanDetails;
	}>();
</script>

<style scoped>
	.container {
		padding: 20px;
	}

	.header {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 48px;
	}

	.header h2 {
		font-size: 16px;
		margin: 0;
	}

	.item {
		display: flex;
		justify-content: space-between;
		margin-bottom: 8px;
		align-items: baseline;
	}

	.label {
		text-wrap: nowrap;
		color: #333;
	}

	.value {
		color: #777;
	}

	span.dots {
		flex-grow: 1;
		border-bottom: 1px dotted #ccc;
		margin: 0 5px;
	}
</style>
